export default {
  title: 'Oups!',
  message1: 'Si vous rencontrez des difficultés à vous connecter',
  message3: ', veuillez ',
  message4: 'nous contacter',
  message5: '.',
};
